import React from 'react';
import './style.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../../Shared/components/controls/Button';

const CardsListCardHeader = ({ image, link }) => (
  <div className="cl-card-header">
    <div className="cl-card-header-image-wrapper">
      <Image field={image} className="cl-card-header-image" />
    </div>
    {link?.value?.href && <Button variant="contained" color="primary" link={link} />}
  </div>
);

export default CardsListCardHeader;
